import { RefObject } from "react";
import { cn } from "~/lib/utils";

type Props = {
    count: number;
    selectedIndex: number;
    progressFillRef: RefObject<HTMLSpanElement | null>;
    onSelect: (index: number) => void;
    label: string;
    className?: string;
    dotClassName?: string;
    progressClassName?: string;
};

export default function CarouselProgressDots({
    count,
    selectedIndex,
    progressFillRef,
    onSelect,
    label,
    className,
    dotClassName,
    progressClassName,
}: Props) {
    return (
        <div className={cn("flex items-center rounded-full px-2 py-2", className)}>
            <div className="flex gap-1 px-1">
                {Array.from({ length: count }, (_, index) => (
                    <button
                        key={index}
                        type="button"
                        aria-label={`Go to ${label} ${index + 1}`}
                        aria-current={index === selectedIndex}
                        onClick={() => onSelect(index)}
                        className={cn(
                            "relative h-1.5 overflow-hidden rounded-full bg-gray200 transition-[width]",
                            index === selectedIndex ? "w-5" : "w-1.5",
                            dotClassName
                        )}
                    >
                        {index === selectedIndex && (
                            <span
                                ref={progressFillRef}
                                className={cn(
                                    "absolute inset-0 origin-left rounded-full bg-primary300",
                                    progressClassName
                                )}
                                style={{ transform: "scaleX(0)" }}
                            />
                        )}
                    </button>
                ))}
            </div>
        </div>
    );
}
